import { render, staticRenderFns } from "./ControlDetalladoPagoDocentePorSedeTab.vue?vue&type=template&id=77279593&scoped=true"
import script from "./ControlDetalladoPagoDocentePorSedeTab.vue?vue&type=script&lang=js"
export * from "./ControlDetalladoPagoDocentePorSedeTab.vue?vue&type=script&lang=js"
import style0 from "./ControlDetalladoPagoDocentePorSedeTab.vue?vue&type=style&index=0&id=77279593&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77279593",
  null
  
)

export default component.exports